import { useEffect, useState } from 'preact/hooks';

export interface Toast {
  id: number;
  text: string;
  action?: { label: string; run: () => void };
}

let current: Toast | null = null;
let seq = 0;
const listeners = new Set<() => void>();

export function toast(text: string, action?: Toast['action']): void {
  const t = { id: ++seq, text, action };
  current = t;
  listeners.forEach((f) => f());
  setTimeout(() => {
    if (current === t) {
      current = null;
      listeners.forEach((f) => f());
    }
  }, action ? 6000 : 2500);
}

export function dismissToast(): void {
  current = null;
  listeners.forEach((f) => f());
}

export function useToast(): Toast | null {
  const [, set] = useState(0);
  useEffect(() => {
    const f = () => set((x) => x + 1);
    listeners.add(f);
    return () => void listeners.delete(f);
  }, []);
  return current;
}
